'use strict';

import "core-js/modules/es.regexp.exec.js";
export default function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}